<script>
export default {
  props: {
    release: {
      type: Object,
      default: () => {},
    },
  },

  data: function () {
    return {
      json: '',
      isSuccessful: false,
      actions: [
        {
          text: 'Refresh',
          icon: 'mdi-refresh',
          action: () => {
            this.refresh()
          },
        },
        {
          text: 'Save to preview',
          icon: 'mdi-content-save',
          action: () => {
            this.save()
          },
        },
      ],
    }
  },
  mounted() {
    this.json = JSON.stringify(this.release.releaseData, undefined, 4)
  },
  methods: {
    save() {
      this.$store.commit('releases/SET_STATE', {
        key: 'preview',
        value: { ...this.release, releaseData: JSON.parse(this.json) },
      })
      this.successToast()
    },
    refresh() {
      this.json = JSON.stringify(this.release.releaseData, undefined, 4)
      this.successToast()
    },
    successToast() {
      this.isSuccessful = true
      setTimeout(() => {
        this.isSuccessful = false
      }, 1000)
    },
  },
}
</script>

<template lang="">
  <div>
    <div class="d-flex my-4">
      <v-btn
        v-for="({ text, icon, action }, index) in actions"
        :key="index"
        class="mr-4"
        depressed
        color="primary darken-1"
        @click="action"
      >
        <v-icon color="white" class="mr-2">{{ icon }}</v-icon>
        {{ text }}</v-btn
      >
      <transition name="fade-down">
        <div v-if="isSuccessful" class="saved-icon pa-1">
          <v-icon class="white--text" size="24" background-color="success"
            >mdi-check</v-icon
          >
        </div>
      </transition>
    </div>
    <v-textarea
      v-model="json"
      solo
      flat
      no-resize
      height="1000"
      background-color="#333"
      :spellcheck="false"
      color="#fff"
      class="json-text-area"
    ></v-textarea>
  </div>
</template>

<style lang="scss">
.json-text-area {
  textarea {
    padding: 16px;
    font-size: 14px;
    color: white !important;
  }
}

.saved-icon {
  height: min-content;
  background-color: #4caf50;
  border-radius: 100%;
}
</style>
